var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"inspire"}},[_c('router-view',{attrs:{"name":"appHeader"}}),_c('div',{attrs:{"id":"app-menu"}}),_c('v-main',{staticClass:"grey lighten-4"},[_c('router-view',{key:_vm.$route.path})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }